function run() {
  const upsellOpenBtn = document.querySelector(".upsell-step-1");
  const upsellWrapper = document.querySelector(".drawer-upsell__wrapper");
  const upsellGoBackBtn = document.querySelector(".drawer-upsell__back");

  upsellOpenBtn?.addEventListener("click", function () {
    upsellWrapper.classList.add("active");
  });

  upsellGoBackBtn?.addEventListener("click", function () {
    upsellWrapper.classList.remove("active");
  });
}

window.addEventListener("load", function () {
  run();
});

subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
  setTimeout(function () {
    run();
  }, 1000);
});
